import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Cue5050FinancialReport } from '../../_models/fundraising/reports/Cue5050FinancialReport';
import { Cue5050, Cue5050DetailView } from '../../_models/fundraising/Cue5050';
import { FundraisingPurchaseInfo, TicketOrder } from '../../_models/fundraising/TicketOrder';
import { Cue5050PurchaseDetailsReport } from '../../_models/fundraising/reports/Cue5050PurchaseDetailsReport';
import { Cue5050PlayersReport } from '../../_models/fundraising/reports/Cue5050PlayersReport';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';
import { BaseService } from '../../_shared/base.service';
import { FundraisingService } from './fundraising.service';


@Injectable()
export class Cue5050Service extends FundraisingService {


  constructor(
    protected http: HttpClient,
    jwtTokenService: JWTTokenService) { 
      super('cue5050', http, jwtTokenService);
    }

    public getById(id: number): Observable<Cue5050> {
      return this.CachedHttpGet<Cue5050>(`fundraising/cue5050/event/${id}`);
    }

    public create(data: Cue5050): Observable<Cue5050[]> {
      this.InvalidateCache(/^fundraising*/);
      return this.http.post<Cue5050[]>(getUrl(`fundraising/cue5050/create`), data, this.requestOptionsAuthenticated('portal'));
    }

    public update(data: Cue5050): Observable<Cue5050[]> {
      this.InvalidateCache(/^fundraising*/);
      return this.http.post<Cue5050[]>(getUrl(`fundraising/cue5050/update`), data, this.requestOptionsAuthenticated('portal'));
    }

    public drawWinner(id: number): Observable<void> {
      this.InvalidateCache(/^fundraising*/);
      return this.http.get<void>(getUrl(`fundraising/cue5050/draw-winner/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public chooseWinner(eventId: number, ticketNumber: string, ticketReferenceNumber: string): Observable<any> {
      const data = { eventId, ticketReferenceNumber, ticketNumber };
      return this.http.post<any>(getUrl(`fundraising/cue5050/choose-winner`), data, this.requestOptionsAuthenticated('portal'));
    }

    public setVerification(firstName: string, lastName: string, eventId: number): Observable<any> {
      return this.http.post<any>(getUrl(`fundraising/cue5050/set-verification/${eventId}`), { firstName, lastName } ,this.requestOptionsAuthenticated('portal'));
    }

    public getWinningTicketOrder(eventId: number): Observable<TicketOrder> {
      return this.http.get<TicketOrder>(getUrl(`fundraising/cue5050/winning-ticket-order/${eventId}`), this.requestOptionsAuthenticated('portal'));
    }

    public getCurrentPot(id: number): Observable<any> {
      return this.http.get<any>(getUrl(`fundraising/site/public/potsize/${id}`));
    }

    public getAllTicketOrders(start: number, pageSize: number, eventId: number, search: string, orderBy: string, orderDir: string): Observable<any> {
      return this.http.get<any>(getUrl(`fundraising/cue5050/ticket-orders?i=${start}&l=${pageSize}&e=${eventId}&s=${search}&o=${orderBy}&d=${orderDir}`), this.requestOptionsAuthenticated('portal'));
    }

    public refundOrder(referenceNumber: string, paymentIntentId: string): Observable<any> {
      return this.http.post<FundraisingPurchaseInfo>(getUrl(`fundraising/cue5050/refund/${referenceNumber}`), JSON.stringify(paymentIntentId), this.requestOptionsAuthenticated('portal'));
    }

    public resendReceipt(referenceNumber: string): Observable<any> {
      return this.http.get(getUrl(`fundraising/cue5050/resend-receipt/${referenceNumber}`), this.requestOptionsAuthenticated('portal'));
    }

    public getEventDetails(id: number): Observable<Cue5050DetailView>{
      return this.http.get<Cue5050DetailView>(getUrl(`fundraising/cue5050/details/${id}`), this.requestOptionsAuthenticated('portal'));
    } 

    public getTicketOrdersByEventId(id: number): Observable<TicketOrder[]> {
      return this.http.get<TicketOrder[]>(getUrl(`fundraising/cue5050/event/${id}/ticket-orders`), this.requestOptionsAuthenticated('portal'));
    }

  }